import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { Table } from 'reactstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';

import RequestState from '../../../types/RequestState';
import globalTranslations from '../../../i18n/globalTranslations';
import Price from '../Price';

@observer
export class ProductQuantityDiscounts extends Component {
  constructor(props) {
    super(props);
    this.maybeLoadDiscounts();
  }

  componentDidUpdate() {
    this.maybeLoadDiscounts();
  }

  maybeLoadDiscounts = () => {
    const { product } = this.props;

    if (product.quantityDiscountsState === RequestState.NONE) {
      product.loadQuantityDiscounts().catch((e) => {
        console.error(e);
      });
    }
  };

  getCellValue = (value, center) => {
    return {
      value: value,
      center: center
    };
  };

  renderHeaderRow = (headers) => {
    return (
      <thead className="thead-light">
        <tr className="ProductQuantityDiscounts__discount-table-header">
          {headers.map((header, index) => {
            return (
              <th
                className={
                  header.center
                    ? 'ProductQuantityDiscounts__discount-table-header-center'
                    : ''
                }
                key={`${header.value}_${index}`}
              >
                {header.value}
              </th>
            );
          })}
        </tr>
      </thead>
    );
  };

  renderDiscountRow = (row) => {
    return (
      <tbody>
        <tr className="ProductQuantityDiscounts__discount-table-row">
          {row.map((cell, index) => {
            return (
              <td
                className={
                  cell.center
                    ? 'ProductQuantityDiscounts__discount-table-cell-center'
                    : 'ProductQuantityDiscounts__discount-table-cell'
                }
                key={`${cell.value}_${index}`}
              >
                {cell.value}
              </td>
            );
          })}
        </tr>
      </tbody>
    );
  };

  renderDiscountTable = () => {
    const { product, withTax } = this.props;
    const showTaxExcludedInfo = !withTax;

    const headerRow = [];
    const cellRow = [];

    headerRow.push(
      this.getCellValue(
        <FormattedMessage {...globalTranslations.quantityTitle} />,
        false
      )
    );
    cellRow.push(
      this.getCellValue(
        <Fragment>
          <FormattedMessage {...globalTranslations.unitPriceTitle} />
          {showTaxExcludedInfo && (
            <Fragment>
              {' '}
              <FormattedMessage {...globalTranslations.taxExcluded} />
            </Fragment>
          )}
        </Fragment>,
        false
      )
    );

    product.quantityDiscounts.forEach((discount) => {
      headerRow.push(
        this.getCellValue(discount.quantity + ' ' + product.stock_unit, true)
      );
      cellRow.push(
        this.getCellValue(
          <Price
            price={discount.price.getPrice(withTax)}
            discount={discount.quantity !== 1}
          />,
          true
        )
      );
    });

    return (
      <Table
        size="sm"
        bordered
        className="ProductQuantityDiscounts__discount-table"
      >
        {this.renderHeaderRow(headerRow)}
        {this.renderDiscountRow(cellRow)}
      </Table>
    );
  };

  render() {
    const { product } = this.props;

    if (product.quantityDiscounts.length === 0) {
      return null;
    }

    return (
      <div className="ProductQuantityDiscounts">
        <div className="ProductQuantityDiscounts__description">
          <FormattedMessage
            id="discount.quantityDescription"
            defaultMessage="Order more and save money!"
          />
        </div>
        <div className="ProductQuantityDiscounts__discount">
          {this.renderDiscountTable()}
        </div>
      </div>
    );
  }
}

ProductQuantityDiscounts.propTypes = {
  product: PropTypes.object.isRequired,
  withTax: PropTypes.bool.isRequired
};

export default inject((stores, props) => ({
  withTax: _.isNil(props.withTax)
    ? stores.accountStore.showPricesWithTax
    : props.withTax
}))(ProductQuantityDiscounts);



// WEBPACK FOOTER //
// ./src/components/product/ProductQuantityDiscounts/index.jsx